import { useEffect } from "react";
import { BUSINESS } from "../data/business";

export function useSEO(title, description, path = "/") {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BUSINESS.siteUrl}${path}`);
  }, [title, description, path]);
}
